import { render, staticRenderFns } from "./BjiImportOrderDetailRecordEditDialog.vue?vue&type=template&id=159a0d8c&lang=pug"
import script from "./BjiImportOrderDetailRecordEditDialog.vue?vue&type=script&lang=js"
export * from "./BjiImportOrderDetailRecordEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports